<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->
<!-- body -->
@if (!loading) {
  <div class="content-page bg-gray">
    <div class="d-flex align-items-center m-0 p-1">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb m-0 p-0">
          <li class="breadcrumb-item"><a [routerLink]="['/settings/corporations']">{{words[language]['corporation'] }}</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{words[language][ type ] }} {{ words[language][ 'detail' ] }}</li>
        </ol>
      </nav>
    </div>
    <!-- general information -->
    @if (!loading) {
      <div class="row">
          <general-information-corporate (childEmitter$)="listenerChildrens($event)" [entity]="type" [entityId]="id"
            [contactId]="contactId" [language]="language" class="col-12" [data]="data">
          </general-information-corporate>
      </div>
    }
    <!-- section sticky toolbar -->
    <section class="sticky-toolbar rounded bg-light">
      <div class="sticky shadow rounded slideleft bg-light d-inline">
        <div type="button" class="btn btn-light btn-sm w-100 p-1 text-left bg-warning text-white"
          title="View Activity Log" disabled>
          <span class="uil-history-alt"></span>
        </div>
      </div>
    </section>
    
    @if (!loading) {
      <!-- address -->
      <div class="row">
        <addresses-corporate class="col-12" [corporate]="data" [contactId]="contactId"
          (addressChanged$)="addressChanged($event)" [language]="language">
        </addresses-corporate>
      </div>
      
      <!-- communications -->
      <div class="row">
        <communications-corporate class="col-12" [corporate]="data" [contactId]="contactId"
          (childEmitter$)="listenerChildrens($event)" [language]="language">
        </communications-corporate>
      </div>
    }

    <!-- inventory setup -->
    @if (type == 'lot' || type == 'corporation') {
      <div class="row">
        <inventory-setup class="col-12" [entityType]="type" [calledFromInventoryList]="false" [entityId]="id"
          (childEmitter$)="listenerChildrens($event)">
        </inventory-setup>
      </div>
    }

    @if (type == 'lot') {
      <div class="row">
        <sales-setup class="col-12" [entityType]="type" [entityId]="id"
          (childEmitter$)="listenerChildrens($event)" [addressChangedEvent]="addressChangedEvent"
        [language]="language"></sales-setup>
      </div>
      <div class="row">
        <collections-setup class="col-12" [entityType]="type" [entityId]="id"
        (childEmitter$)="listenerChildrens($event)" [language]="language"></collections-setup>
      </div>
    }
    @if (detailInfo) {
      <div class="p-3">
        @if (detailInfo.createdBy) {
          <p class="text-dark m-0 p-0">{{words[language][
          'createdBy' ] }}: {{detailInfo.createdBy}}</p>
        }
        @if (detailInfo.createdBy) {
          <p class="text-dark m-0 p-0">{{words[language][
            'createdAt' ] }}: {{detailInfo.createdAt
          | date:'short'}}</p>
        }
        @if (detailInfo.modifiedBy) {
          <p class="text-dark m-0 p-0">{{words[language][
          'modifiedBy' ] }}: {{detailInfo.modifiedBy}}</p>
        }
        @if (detailInfo.modifiedBy) {
          <p class="text-dark m-0 p-0">{{words[language][
            'dateModified' ] }}:{{detailInfo.updatedAt |
          date:'short'}}</p>
        }
      </div>
    }
  </div>
}
<!-- loading -->
@if (loading ) {
  <div class="content-page bg-gray d-flex justify-content-center align-items-center">
    <div class="spinner-grow avatar-lg text-secondary" role="status"></div>
  </div>
}
